<template>
  <v-btn
    color="blue-darken-2"
    size="small"
    class="ma-1"
    variant="elevated"
    v-if="!isAuthenticated && !isLoading"
    @click="handleLogin"
  >
    Inicio Sesión
  </v-btn>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";
const router = useRouter();

const { loginWithPopup, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

const handleLogin = () => {
  try {

 const isMobile = window.matchMedia("(max-width: 768px)").matches;

 if(!isMobile) {
  loginWithPopup()
  .then((res) => {
    try {
      useUser();
      router.push("/start");
    } catch (e) {
      console.log("Error en useUser: " + e);
    }
  })
  .catch((err) => {
    console.error("XXXXError logging in", err);
  });
  return;
}else{



  loginWithRedirect()
  .then((res) => {
    try {
      useUser();
      router.push("/start");
    } catch (e) {
      console.log("Error en useUser: " + e);
    }
  })
  .catch((err) => {
    console.error("XXXXError logging in", err);
  });
  return;
}
  } catch (e) {
    console.log("Error en handleLogin: " + e);
  }
};


</script>
